import React, { SVGAttributes } from 'react';
import { Line as D3Line } from 'd3';
import css from './colors.module.scss';
import { classNames } from '@fullstory/util/fmt';

export interface LineProps<D> extends SVGAttributes<Omit<SVGPathElement, 'd'>> {
  line: D3Line<D>;
  data: D[];
  color?: keyof typeof css;
}

/**
 * Generates a line rendered as an SVG path element.
 *
 * The d attribute is generated internally from a d3 line function for given data.
 *
 * @returns SVG path element
 */
export const Line = <D,>({
  line,
  data,
  color,
  strokeWidth = 2,
  className,
  ...rest
}: LineProps<D>) => (
  <path
    data-component="Line"
    fill="none"
    className={classNames(color ? css[color] : '', className)}
    d={line(data) ?? undefined}
    strokeWidth={strokeWidth}
    data-testid="path"
    {...rest}
  />
);
